import { z } from 'zod';

export const PublicProfilePathSchema = z.object({
  userSlug: z
    .string()
    .regex(/^[a-zA-Z0-9_-]+$/)
    .min(3)
    .max(30),
});

export const AchievementDetailPathSchema = z.object({
  achievementId: z
    .string()
    .refine((val) => !Number.isNaN(Number(val)))
    .transform((val) => Number(val)),
});

export const IdentityDetailPathSchema = z.object({
  identityId: z
    .string()
    .refine((val) => !Number.isNaN(Number(val)))
    .transform((val) => Number(val)),
});
